import { Navigate, useLocation } from "react-router-dom";
import useUserStore from "../stores/user-store";
import { hasAnyPermission } from "../auth/permission-paths";

function ProtectedRoutes({children, permission = null, anyPermissions = []}){
    const loggedIn = useUserStore((state) => state.loggedIn);
    const permissions = useUserStore((state) => state.permissions);
    const location = useLocation();
    const returnTo = `${location.pathname ?? ""}${location.search ?? ""}${location.hash ?? ""}` || "/";
    const loginUrl = `/Auth/Login?returnTo=${encodeURIComponent(returnTo)}`;

    if (!loggedIn) {
        return <Navigate to={loginUrl} replace />;
    }

    const requiredPermissions = permission ? [permission, ...anyPermissions] : anyPermissions;

    if (!hasAnyPermission(permissions, requiredPermissions)) {
        return <Navigate to="/404" replace />;
    }

    return children;
}

export default ProtectedRoutes;
